<script>
export default {
  props: ['value', 'gutter'],
  name: 'tabs',
  data () {
    return {
      tabs: []
    }
  },
  computed: {
    gutterStyle () {
      if (!this.gutter) return {}
      let gutter = this.gutter
      if (typeof this.gutter === 'number') {
        gutter = this.gutter + 'px'
      }
      return { padding: `0 ${gutter}` }
    }
  },
  created () {
    this.tabs = this.$slots.default.map((it) => ({ label: it.componentOptions.propsData.label, name: it.componentOptions.propsData.name }))
  },
  methods: {
    activeClass (label) {
      return label === this.value ? 'active' : ''
    },
    switchTab (label) {
      this.$emit('input', label)
    }
  }
}
</script>

<template>
  <div class="tab_container">
    <div class="tab_head" :style="gutterStyle">
      <div
        v-for="it in tabs"
        :key="it.name"
        :class="activeClass(it.name)"
        @click="switchTab(it.name)"
      >{{it.label}}</div>
    </div>
    <slot></slot>
  </div>
</template>

<style lang="stylus">
.tab_head
  display flex
  margin 15px 0 20px
  justify-content center
  text-align center
  position relative
  left $r = 1px

  > div
    flex 1
    height 30px
    middle-font()
    line-height 28px
    text-align center
    border 1px solid $primary-color
    margin-left (- $r)

    &:first-child
      border-radius 15px 0px 0px 15px
      padding-left 15px

    &:last-child
      padding-right 15px
      border-radius 0px 15px 15px 0px

  .active
    color #fff
    background-color $primary-color
</style>
